// extracted by mini-css-extract-plugin
export default {"styles":"styles___Ozyec","header":"header___zazkY","tab":"tab___i8IlH","item":"item___NXx3s","activated":"activated___YZAFK","body":"body____dFm7"};